<template>
  <div class="note-of-interest" :key="forceUpdate">
    <ConfirmModal
      v-if="confirmDetails"
      :rentalObj="rentalObj"
      @close="closeModal()"
      @confirmSend="commitNoteOfInterest()" />
    <div class="note-of-interest__wrapper">
      <div class="note-of-interest__bg"></div>
      <Loader v-if="showLoader" class="note-of-interest__loader" color="black" />
      <div>
        <div class="note-of-interest__container">
          <h3 class="font-bold font-neue-kabel">Intresseanmälan</h3>
          <div
            v-if="hasActiveNoteOfIntrerest"
            class="note-of-interest__label note-of-interest__label--applied">
            Du är anmäld
          </div>

          <div
            class="note-of-interest__infotext"
            v-if="!hasActiveNoteOfIntrerest && !this.available && this.applied == true">
            Vi synkar dina intresseanmälningar.. Du kan behöva ladda om sidan för att din
            intresseanmälan ska visas
          </div>

          <div v-else>
            <div
              class="note-of-interest__message-container"
              v-if="hasActiveNoteOfIntrerest && !isOffer">
              Du har lämnat en intresseanmälan för {{ rentalObjectTypeText }}.
            </div>
            <div
              class="note-of-interest__message-container"
              v-if="hasActiveNoteOfIntrerest && isOffer">
              Du har lämnat en intresseanmälan och fått ett erbjudande för
              {{ rentalObjectTypeText }}.
            </div>
            <div
              class="note-of-interest__message-container"
              v-else-if="message && !hasActiveNoteOfIntrerest && !justDeleted">
              <p class="note-of-interest__no-apply">Du kan inte anmäla</p>
              <p
                class="note-of-interest__message"
                v-html="message"
                data-test="note-of-interest-message" />
            </div>

            <div class="note-of-interest__infotext">
              <!--  Information om min plats/köpoäng. Visas inte för direktobjekt  -->
              <p
                v-if="
                  !hasActiveNoteOfIntrerest &&
                  (numberOfApplications <= 0 || numberOfApplications == null) &&
                  (!message || justDeleted)
                ">
                Bli först med att anmäla intresse för {{ rentalObjectTypeText }}
              </p>
              <p
                v-else-if="
                  isOnDirektWaitingList &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  (!message || justDeleted)
                ">
                Anmäl intresse för {{ rentalObjectTypeText }}
              </p>

              <p v-if="this.objectType == RENTALOBJECT_TYPES.PREMISE">
                De fem första som anmäler intresse på detta förråd oavsett köpoäng kommer att få ett
                erbjudande.
              </p>

              <!-- Har anmält intresse för objektet -->
              <p
                v-if="
                  !isCar() &&
                  hasActiveNoteOfIntrerest &&
                  !!queuePosition &&
                  (numberOfApplications >= 0 || this.applied == true)
                "
                class="note-of-interest__prel">
                Din preliminära plats är
                <span>
                  {{ queuePosition }} av
                  <span v-if="numberOfApplications != 0 && this.applied">
                    {{ numberOfApplications + 1 }}
                  </span>
                  <span
                    v-else-if="
                      numberOfApplications != 0 &&
                      !this.applied &&
                      queuePosition <= numberOfApplications
                    ">
                    {{ numberOfApplications }}
                  </span>
                  <span
                    v-else-if="
                      numberOfApplications != 0 &&
                      !this.applied &&
                      queuePosition > numberOfApplications
                    ">
                    {{ queuePosition }}
                  </span>
                  <span v-else>1</span>
                </span>
                <span class="block"><button @click="preliminary = true">Vad innebär preliminär plats?</button></span>
              </p>

              <!-- Har anmält intresse för objektet men köpoäng har inte beräknats än -->
              <p
                v-if="
                  !isCar() &&
                  hasActiveNoteOfIntrerest &&
                  !queuePosition &&
                  this.noteofinterestId &&
                  (numberOfApplications > 0 || this.applied == true)
                "
                class="note-of-interest__prel note-of-interest__prel--anim">
                Beräknar din preliminära köplats
              </p>

              <!-- Ej inloggad, topPoints är inte beräknad än -->
              <p
                v-if="
                  !isOnDirektWaitingList &&
                  (!message || justDeleted) &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  topPoints == 0 &&
                  this.authStatus !== AUTH_STATUSES.LOGGEDIN
                "
                class="note-of-interest__prel note-of-interest__prel--anim">
                Beräknar kö
              </p>

              <!-- Ej inloggad, finns intresseanmälningar på objektet -->
              <p
                v-if="
                  !isCar() &&
                  !isOnDirektWaitingList &&
                  topPoints > 0 &&
                  (!message || justDeleted) &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  this.authStatus !== AUTH_STATUSES.LOGGEDIN
                ">
                Den som är på plats
                <strong>1 av {{ numberOfApplications }}</strong>
                anmälda just nu har
                <strong>{{ topPoints }} poäng.</strong>
              </p>

              <!-- Inloggad, finns intresseanmälningar på objektet. Har ej anmält intresse än -->
              <p
                v-if="
                  !isCar() &&
                  !isOnDirektWaitingList &&
                  !!tempQueuePosition &&
                  (!message || justDeleted) &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  this.authStatus === AUTH_STATUSES.LOGGEDIN
                "
                class="note-of-interest__prel">
                Din preliminära plats är
                <span>{{ tempQueuePosition }} av {{ numberOfApplications + 1 }}</span>
                <button @click="preliminary = true">Vad innebär preliminär plats?</button>
              </p>

              <!-- Har anmält intresse för objektet men köpoäng har inte beräknats än -->
              <p
                v-if="
                  !isCar() &&
                  !isOnDirektWaitingList &&
                  !tempQueuePosition &&
                  (!message || justDeleted) &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  this.authStatus === AUTH_STATUSES.LOGGEDIN
                "
                class="note-of-interest__prel--anim">
                Beräknar din preliminära köplats
              </p>

              <!-- Inloggad, finns intresseanmälningar på objektet. Har ej anmält intresse än  -->
              <p
                class="note-of-interest--border"
                v-if="
                  this.authStatus === AUTH_STATUSES.LOGGEDIN &&
                  !message &&
                  !isOnDirektWaitingList &&
                  !hasActiveNoteOfIntrerest &&
                  numberOfApplications > 0 &&
                  topPoints > 0 &&
                  !isCar()
                ">
                Den som är på plats 1 just nu har {{ topPoints }} poäng. Du har
                {{ userQueuePoints }} poäng.
              </p>

              <!-- Objektet är en studentbostad -->
              <div
                v-if="
                  this.subtypeCaption == 'Studentbostad' &&
                  !hasActiveNoteOfIntrerest &&
                  !this.message &&
                  this.authStatus === AUTH_STATUSES.LOGGEDIN
                ">
                <input
                  type="checkbox"
                  name="student"
                  id="student"
                  value="STUDENT"
                  v-model="isStudent" />
                <label for="student">Jag bekräftar att jag är student</label>
              </div>

              <button
                v-if="
                  !message &&
                  !hasActiveNoteOfIntrerest &&
                  this.authStatus === AUTH_STATUSES.LOGGEDIN
                "
                class="note-of-interest__button"
                :disabled="!this.available || !this.isVerifiedStudent"
                :class="!available || !this.isVerifiedStudent ? 'disabled' : ''"
                @click="createNoteofInterest()"
                data-test="note-of-interest-button">
                Anmäl intresse
              </button>
              <button
                @click="toOffers"
                v-if="
                  this.showLink &&
                  (!this.rentalObj.applhasActiveNoteOfIntrerest || !!this.message) &&
                  authStatus
                "
                class="note-of-interest__button note-of-interest__button--primary">
                Till mina
                <span v-if="isOffer">erbjudanden</span>
                <span v-else>intresseanmälningar</span>
              </button>
              <button
                v-if="hasActiveNoteOfIntrerest && !isOffer"
                href="#"
                @click="removeNoteofInterest()"
                class="note-of-interest__trash">
                Ta tillbaka intresseanmälan
              </button>
            </div>
          </div>
          <div
            class="note-of-interest__login-info note-of-interest--border"
            v-if="this.authStatus !== AUTH_STATUSES.LOGGEDIN">
            <p v-if="isCar()">Logga in på Mina sidor för att anmäla intresse.</p>
            <p v-else>
              Logga in på Mina sidor för att kunna se din preliminära plats och anmäla intresse.
            </p>
            <button class="note-of-interest__button" @click="login()">Logga in</button>
            <small>ELLER</small>
            <a class="note-of-interest__login-info__link" href="/mina-sidor/#/register">
              Registrera dig
            </a>
          </div>
        </div>
      </div>

      <Modal v-if="this.preliminary" @cancel="preliminary = false" class="note-of-interest__modal">
        <h2>Preliminär plats</h2>
        <p
          v-if="webapp_config.msg.note_of_intresest_preliminary"
          v-html="webapp_config.msg.note_of_intresest_preliminary"></p>
        <p v-else>
          Observera att det här är en preliminärt beräknad plats och kan ändras vartefter fler
          personer lämnar intresseanmälan.
        </p>
      </Modal>

      <Modal v-if="this.failed" @cancel="failed = null" class="note-of-interest__failed">
        <div class="note-of-interest__failed--icon"></div>
        <h2>Vi ber om ursäkt, något gick snett</h2>
        <p v-html="this.failed"></p>
        <button
          class="note-of-interest__failed__button"
          @click="
            failed = null;
            showLoader = false;
          ">
          Testa igen
        </button>
      </Modal>

      <Modal
        v-if="this.applySuccess"
        @cancel="applySuccess = null"
        class="note-of-interest__success">
        <div class="note-of-interest__success--icon"></div>
        <h2>Din intresseanmälan har skickats in</h2>
        <p
          v-if="webapp_config.msg.noteofinterest_success"
          v-html="webapp_config.msg.noteofinterest_success"></p>
        <p v-else>
          Du kommer strax få en bekräftelse till din mail. Efter att anmälningsperioden är slut
          kommer vi att skicka ut erbjudande om att gå på visning till de med högst poäng.
        </p>
        <p v-if="this.extraMsg">{{ this.extraMsg }}</p>
        <h4>Tips</h4>
        <p class="note-of-interest__success__subtext">
          Du kan hålla dig uppdaterad på dina intresseanmälningar på mina sidor
        </p>
        <button
          @click="toOffers"
          class="note-of-interest__button note-of-interest__button--primary">
          Till mina intresseanmälningar
        </button>
      </Modal>

      <Modal
        v-if="
          showInfo &&
          objectType == RENTALOBJECT_TYPES.APARTMENT &&
          subtypeCaption == 'Studentbostad'
        "
        @cancel="showInfo = false">
        <div v-html="webapp_config.msg.note_of_intresest_info_from_admin_student"></div>
      </Modal>

      <Modal
        v-if="
          showInfo &&
          objectType == RENTALOBJECT_TYPES.APARTMENT &&
          subtypeCaption != 'Studentbostad'
        "
        @cancel="showInfo = false">
        <div v-html="webapp_config.msg.note_of_intresest_info_from_admin_apartment"></div>
      </Modal>

      <Modal
        v-if="
          showInfo &&
          (objectType == RENTALOBJECT_TYPES.PARKING || objectType == RENTALOBJECT_TYPES.PREMISE)
        "
        @cancel="showInfo = false">
        <div v-html="webapp_config.msg.note_of_intresest_info_from_admin_parking_premise"></div>
      </Modal>

      <!--<div>        <a href="#" @click.prevent="showInfo = true">{{subtypeCaption === "Studentbostad" ? "Regler för intresseanmälan gällande studentbostad": "Regler för intresseanmälan"}}</a>
      </div>-->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ConfirmModal from '@/components/vacancy/confirmnoteofinterest';
import Loader from '@/components/ui/loader';
import { mapGetters } from 'vuex';
import Modal from '@/components/ui/modal';
import { replacePlaceholders } from '@/helpers';
import GeneralMixin from '@/mixins/general';
import {
  PARKING_FILTER_TYPES,
  RENTALOBJECT_TYPES,
  WAITING_LIST_TYPES,
  NO_APPLY_REASONS,
  AUTH_STATUSES,
  NOT_A_VACANT_RENTALOBJECT,
} from '@/config/constants';
import { dataLayerPush } from '@/helpers/datalayer';

export default {
  mixins: [GeneralMixin],
  props: {
    rentalObjectCode: {
      type: String,
      required: true,
    },
    typeCaption: {
      type: String,
      required: false,
    },
    objectType: {
      type: String,
      required: false,
    },
    queueText: {
      type: String,
      required: false,
    },
    subtypeCaption: {
      type: String,
      required: false,
    },
  },
  components: { Loader, Modal, ConfirmModal },
  data() {
    return {
      available: true,
      applied: '',
      message: null,
      failed: null,
      extraMsg: null,
      applySuccess: null,
      preliminary: false,
      showLoader: true,
      showInfo: false,
      confirmDetails: false,
      rentalObj: {},
      noteofinterestId: null,
      isStudent: false,
      isVerifiedStudent: false,
      forceUpdate: 0,
      refreshKey: 0,
      justDeleted: false,
      showLink: true,
      RENTALOBJECT_TYPES,
      PARKING_FILTER_TYPES,
      AUTH_STATUSES,
    };
  },

  watch: {
    hasActiveNoteOfIntrerest: {
      immediate: true,
      handler(yes) {
        if (yes) {
          //this.message = this.webapp_config.msg.no_apply_reason_already_applied;
        }
      },
    },
    isStudent: {
      immediate: true,
      handler() {
        if (this.subtypeCaption == 'Studentbostad' && this.authStatus === AUTH_STATUSES.LOGGEDIN) {
          this.isVerifiedStudent = this.isStudent;
        } else {
          this.isVerifiedStudent = true;
        }
      },
    },
  },

  computed: {
    ...mapGetters({
      authStatus: 'authStatus',
      profile: 'profile',
      claims: 'claims',
      noteofinterests: 'noteofinterests',
      webapp_config: 'webapp_config',
      queuePoints: 'queuePoints',
      queuePointsStudent: 'queuePointsStudent',
      queuePointsParking: 'queuePointsParking',
      queuePointsPremise: 'queuePointsPremise',
      queuePointsCultivation: 'queuePointsCultivation',
    }),

    rentalObject() {
      this.refreshKey;

      let temp = this.$store.getters.getVacantObjectByRentalObjectCode(this.rentalObjectCode);
      if (temp) return temp;

      return this.$store.getters.getObjectByObjectCode(this.rentalObjectCode);
    },

    numberOfApplications() {
      this.refreshKey;
      if (!this.rentalObject) return;

      //  if(this.justDeleted == true) return this.rentalObject.numberOfApplications-1;

      return this.rentalObject.numberOfApplications;
    },

    queuePosition() {
      this.refreshKey;
      if (this.numberOfApplications == 0) return 1;
      else return this.$store.getters.getQueuePositionByCode(this.noteofinterestId);
    },

    tempQueuePosition() {
      this.refreshKey;
      return this.$store.getters.getQueuePositionByPoints(this.$route.params.id);
    },

    topPoints() {
      return this.$store.getters.getTopPoints(this.$route.params.id);
    },

    userQueuePoints() {
      let queuePoints = 0;
      if (this.objectType == RENTALOBJECT_TYPES.PARKING) queuePoints = this.queuePointsParking;
      else if (this.objectType == RENTALOBJECT_TYPES.PREMISE) queuePoints = this.queuePointsPremise;
      else if (
        this.objectType == RENTALOBJECT_TYPES.APARTMENT &&
        this.subtypeCaption == 'Studentbostad'
      )
        queuePoints = this.queuePointsStudent;
      else if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) queuePoints = this.queuePoints;
      else if (this.objectType == 'otherRentalObject') queuePoints = this.queuePointsCultivation;
      return queuePoints;
    },

    /**
     * Är detta ett "direktobjekt" ?
     */
    isOnDirektWaitingList() {
      if (!this.rentalObject) return;

      return [
        WAITING_LIST_TYPES.PARKING_DIREKT,
        WAITING_LIST_TYPES.PREMISES_DIREKT,
        WAITING_LIST_TYPES.STUDENT_DIREKT,
        WAITING_LIST_TYPES.LGH_DIREKT,
      ].some((t) => t == this.rentalObject.waitingListType);
    },

    rentalObjectTypeText() {
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) return 'den här bostaden';
      else if (this.objectType == RENTALOBJECT_TYPES.PARKING) return 'den här fordonsplatsen';
      else if (this.objectType == RENTALOBJECT_TYPES.PREMISE) return 'den här lokalen';
      else return 'det här objektet';
    },

    /**
     * Kollar om man har anmält intresse på objektet.
     */
    hasActiveNoteOfIntrerest() {
      this.refreshKey;
      if (this.justDeleted == true) return false;
      this.noteofinterestId = this.$store.getters.getRentalObjectCodeNoteOfInterest(
        this.$route.params.id,
      );

      clearTimeout(this.timeout);
      if (!this.noteofinterestId && this.applied) {
        this.timeout = setTimeout(() => {
          return this.refreshKey++;
        }, 5000);
      }

      return (
        this.$store.getters.isRentalObjectCodeCurrentOffer(this.$route.params.id) ||
        this.noteofinterestId
      );
    },

    isOffer() {
      this.refreshKey;
      return this.$store.getters.isRentalObjectCodeCurrentOffer(this.$route.params.id);
    },
  },

  methods: {
    init() {
      if (this.rentalObject.noApplyReason == NO_APPLY_REASONS.NOT_PUBLISHED) {
        this.message = 'Detta objekt är inte publicerat';
        this.available = false;
      }

      this.rentalObj = this.rentalObject;

      if (this.$route.params.id && this.available && !this.isCar())
        this.$store.dispatch('fetchObjectTopQueuePostion', this.$route.params.id);

      /**
       * Om man är inloggad, ska man först kolla om man redan intresseanmält sig på detta objekt
       */
      if (this.authStatus === false) {
        this.showLoader = false;
      } else {
        // Är man inloggad hämtas massa data för att kunna kolla om man gjort en intresseanmälan
        return Promise.all([
          this.$store.cache.dispatch('fetchProfile'), // < Behövs för att kolla age
          this.$store.dispatch('fetchNoteofinterests'),
          this.$store.cache.dispatch('fetchOffers'),
          this.getNoApplyReason(),
        ])
          .then(() => {
            if (this.available)
              this.$store.cache.dispatch('getQueuePoints', this.profile.contactCode);
          })
          .finally((result) => {
            this.showLoader = false;
            clearTimeout(this.timeoutQueue);
            this.timeoutQueue = setTimeout(() => {
              if (!this.isCar()) {
                if (this.noteofinterestId)
                  this.$store.dispatch('fetchSingleObjectQueuePostion', this.noteofinterestId);
                else this.$store.dispatch('fetchSingleObjectPrelQueuePostion', this.$route.params.id);
              }
            }, 5000);

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              return this.refreshKey++;
            }, 12000);

            /**
             * Inga särskilda villkor ouppfyllda. Bail.
             */
            if (!this.rentalObject.noApplyReason) return;

            /**
             * Något är fel. kollar vad.
             */

            if (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.NO_APARTMENTCONTRACTS) {
              this.message = this.webapp_config.msg.no_apply_reason_no_appartment_contracts;
              this.available = false;
            }

            if (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.COMPANY) {
              this.message = this.webapp_config.msg.no_apply_reason_company;
              this.available = false;
              this.showLink = false;
            }

            if (
              this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_MANY &&
              this.refreshKey < 2
            ) {
              this.message = this.webapp_config.msg.no_apply_reason_too_many;
              this.available = false;
            }

            if (
              this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.ALREADY_APPLIED &&
              this.hasActiveNoteOfIntrerest
            ) {
              this.message = this.webapp_config.msg.no_apply_reason_already_applied;
              this.available = false;
            }

            if (
              this.rentalObject.noApplyReason.code ==
              NO_APPLY_REASONS.NO_APARTMENTCONTRACTS_IN_VATAREA
            ) {
              this.message = replacePlaceholders(
                this.webapp_config.msg.no_apply_reason_no_appartment_contracts_in_vatarea,
                [this.rentalObject.vatArea],
              );
              this.available = false;
            }

            if (
              this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.MAX_AGE ||
              this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_OLD
            ) {
              this.message = replacePlaceholders(this.webapp_config.msg.no_apply_reason_max_age, [
                this.rentalObject.noApplyReason.maxAge,
              ]);
              this.available = false;
            }

            // min_age is false positive if the person is protected, because civicnumber starts with 9999
            if (
              (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.MIN_AGE ||
                this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_YOUNG) &&
              !this.$store.getters.civicNumberIsProtected
            ) {
              this.message = replacePlaceholders(this.webapp_config.msg.no_apply_reason_min_age, [
                this.rentalObject.noApplyReason.minAge,
              ]);
              this.available = false;
            }

            if (this.rentalObject.noApplyReason.code === NO_APPLY_REASONS.SECONDARY_TENANT) {
              this.message = this.webapp_config.msg.no_apply_reason_no_appartment_contracts;
              this.available = false;
            }

            //TODO: Lägg in i webapp_config
            if (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.BLOCKED) {
              this.message = replacePlaceholders('Ditt konto är spärrat t.o.m. {0}', [
                dayjs(this.rentalObject.noApplyReason.blockedUntil).format('YYYY-MM-DD'),
              ]);
              this.available = false;
            }
          });
      }
    },

    createNoteofInterest() {
      this.failed = null;
      /**
       * Kollar först så man får göra intresseanmälan
       */
      if (!this.available) return;

      this.showLoader = true;
      if (this.authStatus !== AUTH_STATUSES.LOGGEDIN) {
        location.href =
          this.webapp_config.url_to_mypages +
          '/#/login?returnUrl=' +
          encodeURIComponent(location.href);

        return;
      }

      this.confirmDetails = true;
      this.showLoader = false;
    },

    removeNoteofInterest() {
      // e.preventDefault();

      if (this.noteofinterestId) {
        this.showLoader = true;
        return this.$store.dispatch('removeNoteofInterest', this.noteofinterestId).finally(() => {
          this.justDeleted = true;
          this.available = true;
          this.showLoader = false;
          this.forceUpdate++;
        });
      }
    },

    commitNoteOfInterest() {
      this.showLoader = true;
      this.closeModal();
      this.extraMsg = null;
      return this.$store
        .dispatch('createNoteofInterest', this.rentalObjectCode)
        .then(() => {
          this.justDeleted = false;
          dataLayerPush({
            event: 'anmalIntresse',
            objectNumber: this.rentalObjectCode,
            objectType: this.typeCaption,
          });

          /**
           * Om detta är ett direktobjekt kommer inte erbjudandena uppdateras direkt i xpand. Det tar ett tag.
           *
           * Detta måste användaren få veta..
           */
          if (this.isOnDirektWaitingList) {
            this.message = this.webapp_config.msg.note_of_intereset_on_torgetdirekt_message;
          }

          this.applied = true;
          this.applySuccess = true;

          if (!this.isOnDirektWaitingList) {
            return Promise.all([
              // Hämtar objektet på nytt eftersom antalet intresseanmälningar nu borde ha ökat och detta måste skrivas ut.
              this.$store.dispatch('fetchSingleRentalObject', this.rentalObjectCode),

              // Vissa intresseanmälningar blir direkt ett erbjudande
              this.$store.dispatch('fetchOffers'),
            ]).then(() => {
              this.available = false;
              this.init();
            });
          } else {
            this.available = false;
            this.init();
          }
        })
        .catch((error) => {
          this.failed = error.response.data.description;
          if (
            error.response.data.description.includes(
              'Could not get PublishedRentalObject from origin',
            ) &&
            this.isOnDirektWaitingList
          ) {
            this.available = false;
            this.applied = true;
            this.applySuccess = true;
            this.extramsg = this.webapp_config.msg.note_of_intereset_on_torgetdirekt_message;
            this.failed = null;
            this.init();
          } else {
            if (!error.response.data.description)
              this.failed = 'Din intresseanmälan misslyckades tyvärr';
            this.applySuccess = false;
            this.applied = false;
            this.available = true;
          }
          /**
           * Om detta är ett direktobjekt kommer inte erbjudandena uppdateras direkt i xpand. Det tar ett tag.
           *
           * Detta måste användaren få veta.. Antingen när den klickat på knappen och det gått OK
           * erller om den klickat på knappen och fått fel att det redan finns en anmälan.
           */
          if (
            this.failed == 'Det finns redan ett erbjudande på objektet' &&
            this.isOnDirektWaitingList
          ) {
            this.failed = this.webapp_config.msg.note_of_intereset_on_torgetdirekt_message;
          }
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    closeModal() {
      this.confirmDetails = false;
    },

    login() {
      if (location.host == 'stage.gavlegardarna.se'){
        location.href =
          '/ny-inloggning?returnUrl=' +
          encodeURIComponent(location.href);
      } else {
        location.href =
          '/logga-in?returnUrl=' +
          encodeURIComponent(location.href);
      }

    },

    toOffers() {
      location.href = this.webapp_config.url_to_mypages + '/#/erbjudanden';
    },

    getNoApplyReason() {
      if (!this.rentalObject.noApplyReason) return;

      /**
       * Kunden kan inte anmäla intresse för detta objekt pga:
       */
      if (
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.NOT_LOGGED_IN ||
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.NOT_LOGGER_IN
      ) {
        this.message = this.webapp_config.msg.no_apply_reason_not_logged_in;
        this.available = false;
      }

      if (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.NO_APARTMENTCONTRACTS) {
        this.message = this.webapp_config.msg.no_apply_reason_no_appartment_contracts;
        this.available = false;
      }

      if (
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_MANY &&
        this.refreshKey < 2
      ) {
        this.message = this.webapp_config.msg.no_apply_reason_too_many;
        this.available = false;
      }

      if (
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.NO_APARTMENTCONTRACTS_IN_VATAREA
      ) {
        this.message = replacePlaceholders(
          this.webapp_config.msg.no_apply_reason_no_appartment_contracts_in_vatarea,
          [this.rentalObject.vatArea],
        );
        this.available = false;
      }

      if (
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.MAX_AGE ||
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_OLD
      ) {
        this.message = replacePlaceholders(this.webapp_config.msg.no_apply_reason_max_age, [
          this.rentalObject.noApplyReason.maxAge,
        ]);
        this.available = false;
      }

      // min_age is false positive if the person is protected, because civicnumber starts with 9999
      if (
        (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.MIN_AGE ||
          this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.TOO_YOUNG) &&
        !this.$store.getters.civicNumberIsProtected
      ) {
        this.message = replacePlaceholders(this.webapp_config.msg.no_apply_reason_min_age, [
          this.rentalObject.noApplyReason.minAge,
        ]);
        this.available = false;
      }

      //TODO: Lägg in i webapp_config
      if (this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.BLOCKED) {
        this.message = replacePlaceholders('Ditt konto är spärrat t.o.m. {0}', [
          dayjs(this.rentalObject.noApplyReason.blockedUntil).format('YYYY-MM-DD'),
        ]);
        this.available = false;
      }

      if (
        this.rentalObject.noApplyReason.code == NO_APPLY_REASONS.ALREADY_APPLIED ||
        this.hasActiveNoteOfIntrerest
      ) {
        this.message = this.webapp_config.msg.no_apply_reason_already_applied;
        this.available = false;
      }
    },
  },

  created() {
    this.init();
  },
};
</script>


<style lang="scss" scoped>
.note-of-interest {
  position: relative;
  margin-bottom: 2em;
  min-height: 120px !important;
  border-radius: 4px;
  border: solid 1px $lightgray;
  background-color: #F9F9F9;
  color: $textcolorblack;

  &__loader {
    position: absolute !important;
    left: calc(50% - 35px);
    top: 100px;
    z-index: 2;
  }

  &__success {
    h4 {
      margin-top: 22px;
    }
    &--icon {
      margin: 0 auto 20px;
      width: 42px;
      height: 42px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-complete.svg);
      background-size: contain;
    }

    &__subtext {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 32px;
    }

    .note-of-interest__button {
      margin: 0;
      text-align: center;
    }
  }

  &__modal {

  }

  &__failed {
    &--icon {
      margin: 0 auto 20px;
      width: 26px;
      height: 39px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-error.svg);
    }

    &__button {
      background: $abgblue!important;
      color: $textcolorwhite;
      font-weight: bold;
      font-size: 18px!important;
      letter-spacing: 0.27px;
      cursor: pointer;
      font-family: $sansserif;
      margin-top: 20px;
      padding: 20px;
      text-transform: none;
      border: none;
      width: 100%;

      @media (min-width: 800px) {
        width: auto;
      }
    }
  }

  &__message-container {
    //padding-bottom: 18px;
    margin-top: 10px;
    // margin-bottom: 18px;
    // border-bottom: 1px solid $lightgray;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    border-bottom: 1px solid $lightgray;
    margin-bottom: 18px;
    padding-bottom: 18px;
  }

  &__no-apply {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin-bottom: 12px;
    padding: 6px 8px 4px;
    border-radius: 2px;
    background-color: $lightgray;
    font-weight: bold;
    color: $darkgray;
    font-size: 14px;
    line-height: 1.2;

    &:before {
      content: '';
      display: inline-block;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-prohibit.svg);
      width: 16px;
      height: 16px;
      background-size: contain;
      margin-right: 8px;
      margin-top: -2px;
    }
  }

  &__message {
    line-height: 1.4;
  }

  &__error {
    border-left: 6px solid $pink;
    padding: 24px 32px 28px 25px;
    border-radius: 4px;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.16);
    background-color: $backgroundcolorwhite;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
  }

  a {
    color: $abgblue;
    font-weight: bold;
    line-height: 1.44;
    display: block;
  }

  h3 {
    font-size: 18px;
  }

  input[type='checkbox'] {
    margin-right: 8px;
    -ms-transform: scale(1.5); /* IE */
    -moz-transform: scale(1.5); /* FF */
    -webkit-transform: scale(1.5); /* Safari and Chrome */
    -o-transform: scale(1.5); /* Opera */
    transform: scale(1.5);
    padding: 7px;
    cursor: pointer;
  }

  input[type='checkbox'] + label {
    font-size: 16px;
  }

  &__wrapper {
    overflow: hidden;
    position: relative;
  }

  &__bg {
    width: 322px;
    height: 322px;
    position: absolute;
    left: calc(100% - 220px);
    top: -220px;
    z-index: 1;
    background-color: #FFEA00;
    border-radius: 50%;
    display: inline-block;
  }

  &__container {
    padding: 25px 24px 14px;
    position: relative;
    z-index: 1;
  }

  &__label {
    display: inline-flex;
    align-items: center;
    background-color: $darkgreen;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    padding: 4px 9px 2px;
    border-radius: 2px;
    margin-top: 8px;
  }

  &__prel {

    padding-bottom: 8px;

    &--anim:after {
      color: black;
      content: '.';
      animation: dots 1.3s steps(5, end) infinite;}


    a, button {
      font-family: $sansserif;
      font-size: 16px;
      margin-top: 6px;
      font-weight: 600!important;
      border: none;
      padding: unset;
      outline: none;
      background: unset;
      color: $abgblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &__trash {
    display: flex!important;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: unset;
    outline: unset;
    background: unset;
    color: $abgblue;
    font-weight: bold;
    text-decoration: underline;
    margin: 0 auto 10px;
    cursor: pointer;

    &:after {
      content: '';
      display: inline-block;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-trash-blue.svg);
      width: 24px;
      height: 24px;
      margin-left: 6px;
    }
  }


  &__infotext {

    p {
      font-size: 18px;
      margin-bottom: 8px;
      max-width: 300px;
    }

    span {
      font-weight: bold;
      font-size: 24px;
    }
  }

  &--border {
    border-top: 1px solid $lightgray;
    padding-top: 18px;
    margin-top: 18px;
  }

  &__login-info {
    p {
      font-size: 14px;
      line-height: 18.2px;
    }

    small {
      display: block;
      font-size: 12px!important;
      text-align: center;
    }

    &__link, a {
      font-size: 18px;
      text-align: center;
      margin-top: 16px;
      color: $abgblue;
      margin-bottom: 26px;
    }
  }

  &__button {
    width: 100%;
    text-align: center;
    margin-top: 18px;
    margin-bottom: 14px;
    padding: 12px 30px;
    border-radius: 6px;
    border: solid 2px $abgblue;
    background-color: $abgblue;
    font-size: 18px;
    font-weight: bold;
    color: #fff!important;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.2s;

    span {
      font-size: 18px;
    }

    &:disabled {
      cursor: default;
      background-color: $gray;
      border-color: $gray;
    }

    &:not(:disabled):hover  {
      background-color: $abghoverblue;
    }
  }
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity .5s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: black;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 black;}}
</style>

<style>
.x-modal-container .x-modal.md {
  background-color: #fff;
}
.x-modal-container .x-modal .x-modal-inside .x-modal-content {
  padding-bottom: 0!important;
  padding-left: 20px;
  padding-right: 20px;
}

.x-modal-content p {
  font-size: 18px;
  line-height: 28px;
}

.sk-loader.tinted .sk-circle .sk-child:before {
  background-color: black!important;
}
</style>
